import React from 'react';
import SearchResultHeader from '../SearchResultHeader/SearchResultHeader';
import SearchResultBody from './SearchResultBody';
import SearchResultFooter from './SearchResultFooter';
import SearchResultLimitNotice from './SearchResultLimitNotice';

const MAX_PAGES = 5;
const MAX_PAPERS = 100;

export default function SearchResults({
  query,
  page,
  documents,
  results = {},
}) {
  const {
    total,
    limit,
    itemsByPage,
  } = results;

  const pageItems = itemsByPage && itemsByPage[page];
  const items = Array.isArray(pageItems)
    ? pageItems.map(id => documents[id])
    : pageItems;

  return (
    <div>
      <SearchResultHeader
        title="Papers"
        currentPage={page}
        itemsPerPage={limit}
        itemsCount={items && items.length}
        total={total}
        maxPages={MAX_PAGES}
        query={query}
      />
      <SearchResultBody
        items={items}
        query={query}
        currentPage={page}
      />
      <SearchResultLimitNotice
        currentPage={page}
        maxPages={MAX_PAGES}
        total={total}
        maxPapers={MAX_PAPERS}
      />
      <SearchResultFooter
        query={query}
        total={total}
        itemsPerPage={limit}
        currentPage={page}
        maxPages={MAX_PAGES}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/SearchResults/SearchResults.js